import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useMutation } from 'react-query';
import SaveConfigurationService from './SaveConfigurationService';
import {
  changeIsSummaryOpened, refreshSelectionDeadlines,
  downloadPdf, requestBudget,
  requestBudgetComplete,
  setSnackbarMessage,
} from '../model/configuratorSlice';
import { EndPoints, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import UserService from './UserService';

export default function RequestBudgetService() {
    const { promotionSlug, currentUnit, token } = useSelector(state => state.configurator);
    const saveConfigurationMutation = SaveConfigurationService();
    const userMutation = UserService();
    const dispatch = useDispatch();

    const callback = () => {
        const unitId = currentUnit !== null ? currentUnit.id : 0;
        const requestBudgetUrl = `${EndPoints.RequestBudget}/${promotionSlug}/unit/${unitId}/request-budget`;

        const data = {
          token,
        };

      dispatch(requestBudget());
      dispatch(changeIsSummaryOpened(false));

      axios
            .post(requestBudgetUrl, data)
            .then((response) => {
                dispatch(changeIsSummaryOpened(false));
                dispatch(setSnackbarMessage(FeedbackMessages.RequestBudgetSuccess));
                dispatch(requestBudgetComplete());
            })
            .catch((error) => {
                dispatch(requestBudgetComplete());
                if (error.response?.data?.code === 'selection_expired') {
                    dispatch(refreshSelectionDeadlines(error.response.data.expired_selections));
                } else dispatch(setSnackbarMessage(FeedbackMessages.RequestBudgetError));
            });
    };

    return useMutation(['requestBudgetQuery'], () => {
        saveConfigurationMutation.mutate(callback);
    });
}
